import fetch from "auth/FetchInterceptor";

const AuditLogService = {};

AuditLogService.getAuditLog = function (data) {
  return fetch({
    url: "/get-audit-log",
    method: "post",
    data: data,
  });
};

export default AuditLogService;
